import { path } from "@Services/url";
import firebase, { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { getToken, onMessage } from "firebase/messaging";

const config = {
  apiKey: "AIzaSyBvMZgBVjZnmnW3MCERh5vXII8__blw7oM",
  projectId: "newcar8891",
  messagingSenderId: "1098234151517",
  appId: "1:1098234151517:web:a57833e77c3aa07d",
  measurementId: "G-E4RGW5524X",
};
async function pushRegisterDevice(currentToken: any) {
  await fetch(path.newCarApiV2 + "/firebaseToken", {
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: `from=9&pushToken=${currentToken}&device_id=${localStorage.getItem("uuid")}`,
  });
}

function sendStat(msg_id: any, type: any) {
  if (!msg_id && msg_id != "undefined") return false;
  var body = {
    msg_id: msg_id,
    device_id: msg_id,
    type: type,
    platform: "touch",
  };
  var opts = {
    method: "POST",
    body: JSON.stringify(body),
  };
  var url = "https://dc.8891.tw/api/pushDataCollection";
  return fetch(url, opts)
    .then(function (response) {
      if (response.status != 200) {
        console.log("push sendStat error");
      }
    })
    .catch(function (err) {});
}

function initializeFireBase() {
  try {
    isSupported().then((supported) => {
      if (supported) {
        const firebaseApp = initializeApp(config);
        const messaging = getMessaging(firebaseApp);

        onMessage(messaging, (payload: any) => {
          const notificationTitle = payload.data.title;
          const notificationOptions = {
            body: payload.data.body,
            icon: payload.data.icon,
            image: payload.data.image,
            tag: payload.data.tag,
            data: { click_action: payload.data.link, msg_id: payload.data.msg_id },
            requireInteraction: payload.data.requireInteraction,
          };
          var notification = new Notification(notificationTitle, notificationOptions);

          notification.onclick = function (event) {
            sendStat(event.target.data.msg_id, "open");
            window.open(event.target.data.click_action);
            notification.close();
          };
        });

        navigator.serviceWorker
          // .register("/m/static/init_sw.js")
          .register("/firebase-messaging-sw.js?v=123123")
          .then(function (registration) {
            // 请求推送许可
            Notification.requestPermission()
              .then(function (permission) {
                if (permission === "granted") {
                  console.log("使用者已授予推送許可");

                  // 获取推送许可令牌
                  return getToken(messaging);
                } else {
                  console.log("使用者未授予推送許可");
                }
              })
              .then(function (token) {
                console.log(token);
                if (!!token) {
                  pushRegisterDevice(token);
                  // 将推送许可令牌发送到你的服务器，以便将来发送推送消息
                }
                return token;
              })
              .catch(function (error) {
                console.log("獲取推送許可出錯： ", error);
              });

            // 注册成功
            console.log("Service Worker 註冊成功：", registration.scope);
          })
          .catch(function (error) {
            // 注册失败
            console.log("Service Worker 註冊失敗：", error);
          });
      }
    });
  } catch (e) {
    console.log(e);
  }
}

export default initializeFireBase;
